export const PRIMARY_COLOR = '#D52941'
export const SECONDARY_COLOR = '#2ba5f7'
export const SECONDARY_COLOR_RGB = '43,165,247'

export const PURPLE_COLOR = '0,64,122'
export const PURPLE_COLOR_PLAIN = '#185186'
export const PURPLE_COLOR_DARK = '#001A31'

